const steps = [
  {
    num: '01',
    icon: 'ri-chat-3-line',
    title: 'Initial Consultation',
    desc: 'We review your project scope, timeline, and goals. Every inquiry is personally evaluated — no automated bidding.',
    img: 'https://public.readdy.ai/ai/img_res/1be062bc09c953e88f8d6008d77a7180.jpg',
  },
  {
    num: '02',
    icon: 'ri-file-search-line',
    title: 'Site Evaluation & Plan Review',
    desc: 'We assess site conditions, review lease requirements, and confirm construction specifications before a single nail is driven.',
    img: 'https://readdy.ai/api/search-image?query=construction%20project%20manager%20walking%20through%20an%20empty%20commercial%20space%20holding%20architectural%20plans%20doing%20a%20site%20evaluation%2C%20professional%20attire%2C%20clean%20interior%2C%20warm%20natural%20light%2C%20editorial%20photography&width=400&height=260&seq=proc2&orientation=landscape',
  },
  {
    num: '03',
    icon: 'ri-government-line',
    title: 'Permitting & Coordination',
    desc: 'We handle all Henry County permitting, coordinate with local building departments, and schedule inspections proactively.',
    img: 'https://readdy.ai/api/search-image?query=contractor%20submitting%20building%20permit%20documents%20at%20a%20county%20office%20desk%2C%20official%20paperwork%20and%20stamps%2C%20professional%20clean%20setting%2C%20warm%20neutral%20tones%2C%20editorial%20photography%20style&width=400&height=260&seq=proc3&orientation=landscape',
  },
  {
    num: '04',
    icon: 'ri-tools-line',
    title: 'Managed Construction',
    desc: 'Our team coordinates all trades — framing, electrical, plumbing, HVAC, finishes — with daily oversight and accountability.',
    img: 'https://readdy.ai/api/search-image?query=active%20commercial%20construction%20site%20with%20workers%20framing%20walls%20and%20installing%20electrical%20systems%20in%20a%20retail%20build-out%2C%20organized%20professional%20crew%2C%20warm%20light%2C%20clean%20background%2C%20editorial%20photography&width=400&height=260&seq=proc4&orientation=landscape',
  },
  {
    num: '05',
    icon: 'ri-checkbox-circle-line',
    title: 'Final Inspection & Turnover',
    desc: 'We conduct a thorough walkthrough, address any punch-list items, and deliver a clean, code-compliant space ready for occupancy.',
    img: 'https://readdy.ai/api/search-image?query=contractor%20handing%20keys%20to%20a%20business%20owner%20in%20front%20of%20a%20beautifully%20completed%20commercial%20interior%20space%2C%20bright%20clean%20finished%20room%2C%20professional%20warm%20lighting%2C%20simple%20background%2C%20editorial%20photography&width=400&height=260&seq=proc5&orientation=landscape',
  },
];

export default function Process() {
  return (
    <section id="process" className="py-24 bg-stone-950 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-900/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-900/10 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-amber-600" />
            <span className="text-amber-500 text-xs font-semibold tracking-[0.2em] uppercase">
              How We Work
            </span>
            <div className="w-8 h-px bg-amber-600" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Construction Process
          </h2>
          <p className="text-stone-400 mt-4 text-base max-w-xl mx-auto leading-relaxed">
            A structured, transparent process that keeps your project on time, on budget, and fully compliant from day one.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {steps.map((step) => (
            <div
              key={step.num}
              className="bg-stone-900 rounded-2xl overflow-hidden border border-stone-800 flex flex-col group hover:border-amber-700/50 transition-all duration-300"
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden flex-shrink-0">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                {/* Step number + icon */}
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-8 h-8 flex items-center justify-center bg-amber-700 rounded-full text-white text-xs font-bold flex-shrink-0">
                    {step.num.replace('0', '')}
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className={`${step.icon} text-amber-500 text-lg`} />
                  </span>
                </div>

                <h3 className="text-white font-bold text-sm mb-2 leading-snug">{step.title}</h3>
                <p className="text-stone-400 text-xs leading-relaxed flex-1">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
